import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        selectionList({dispatch}) {
            return new Promise((resolve) => {
                axios.get(
                    '/api/excursion-manager/excursions/selection-list'
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        fetch({commit, dispatch}) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return axios.get(
                '/api/excursion-manager/excursions/list',
            ).finally(() => {
                commit('TOGGLE_PRELOADER', false, {root: true})
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        add({commit, dispatch}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/excursion-manager/excursions/add',
                    prepareData(data)
                ).then(({data}) => {
                    resolve(data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        edit({commit, dispatch}, editedItem) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/excursion-manager/excursions/edit/' + editedItem.id,
                    prepareData(editedItem)
                ).then(({data}) => {
                    resolve(data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({commit, dispatch}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/excursion-manager/excursions/dell/' + itemId
                ).then(() => {
                    resolve()
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
    }
}

function prepareData (data) {
    const fd = new FormData()
    if (data.image) {
        fd.append('image', data.image)
    }
    fd.append('name', data.name)
    fd.append('intro', data.intro)
    fd.append('price', data.price)
    fd.append('days', data.days)
    fd.append('time', data.time)
    data.hotelIDs.forEach(element => fd.append('hotelIDs[]', element));
    fd.append('category_id', data.category_id)
    if (data.description) {
        fd.append('description', data.description)
    }
    if (data.price_note) {
        fd.append('price_note', data.price_note)
    }

    if (data.price_value) {
        fd.append('price_value', data.price_value)
    }
    fd.append('published', Number(data.published))

    return fd
}
